import React from 'react';
export const DoubleCheck = ({
  className = 'w-6 h-6',
  animate = false
}: {
  className?: string;
  animate?: boolean;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={`${className} ${animate ? 'animate-pulse' : ''}`} data-id="element-77">
    <polyline points="18 6 7 17 2 12" data-id="element-78"></polyline>
    <polyline points="22 6 11 17 8 14" data-id="element-79"></polyline>
  </svg>;